// extracted by mini-css-extract-plugin
module.exports = {"select":"hour-span-selector_select__2_UcX"};